import React from 'react';
import {Input} from "antd";
import {injectIntl} from "react-intl";
import './SATextArea.css';
import FieldError from "./FieldError";

const {TextArea} = Input;

class SATextArea extends React.Component {

  render() {
    const {value, onChange, error, className, ...attributes} = this.props;
    const errorClassName = error ? " error" : '';

    return (
      <div className={className + errorClassName}>
        <TextArea onChange={onChange} value={value} {...attributes}/>
        {error && (
          <FieldError error={error}/>
        )}
      </div>
    );
  }
}

export default injectIntl(SATextArea);
